import { LockOutlined } from '@ant-design/icons';
import { Form, Tag } from 'antd';
import React, { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';

import { useEffectiveRoomDiscount } from '../../../hooks/useEffectiveRoomDiscount';
import styles from '../ExperienceDiscount.module.scss';

type RoomDiscountPreviewProps = {
  onToggle: () => void;
};

export const RoomDiscountPreview = ({ onToggle }: RoomDiscountPreviewProps) => {
  const { currencyFormatter } = useContext(CurrencyContext);

  const form = Form.useFormInstance<{
    averageRoomPrice: number;
    defaultNightRoomDiscount: number;
  }>();

  const averageRoomPrice = Form.useWatch('averageRoomPrice', form);
  const effectiveRoomDiscount = useEffectiveRoomDiscount();

  return (
    <div className={styles.wrapper}>
      <p className={styles.sectionTitle}>ROOM DISCOUNT</p>
      <div className={styles.room}>
        <div className={styles.packHeader} onClick={onToggle}>
          <div className={styles.leftPart}>
            <div className={styles.texts}>
              <p className={styles.roomTitle}>Room</p>
              <p className={styles.subtitle}>
                <span className={styles.description}>
                  <LockOutlined /> Configured above
                </span>
              </p>
            </div>
          </div>
          <div className={styles.rightPart}>
            <div className={styles.priceBlock}>
              {!!effectiveRoomDiscount && <Tag>-{effectiveRoomDiscount}%</Tag>}
              <p className={styles.subtitle}>
                {averageRoomPrice === null ||
                averageRoomPrice === undefined ||
                effectiveRoomDiscount === undefined ? (
                  <span className={styles.errorMessage}>
                    {!averageRoomPrice
                      ? 'Average BAR required'
                      : 'Room discount required'}
                  </span>
                ) : (
                  <div className={styles.priceWrapper}>
                    <span className={styles.discountedPrice}>
                      {currencyFormatter(
                        Math.round(
                          averageRoomPrice * (1 - effectiveRoomDiscount / 100)
                        )
                      )}
                    </span>
                    <span className={styles.originalPrice}>
                      {currencyFormatter(averageRoomPrice)}
                    </span>
                  </div>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
